import "./ultimi-articoli.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';

const UltimiArticoli = ({articles}) => {
    
    const navigate = useNavigate();

    return (
        <div className="last-articles">
            <h2 className="small-title">Ultimi articoli</h2>
            <div className="last-articles-container">
                {articles.slice(0,3).map((article) => (
                    <div key={article.id} className="article-card">
                        <h4>{article.date} - {article.author}</h4>
                        <h3 onClick={() => navigate(`/articoli/${article.id}`)} >{article.title}</h3>
                    </div>
                ))}
            </div>
            <button className="scopri-btn" onClick={() => navigate(`/articoli`)}>
                Tutti gli articoli <FontAwesomeIcon icon={faChevronRight} />
            </button>
        </div>
    );
};

export default UltimiArticoli;
